/* Ponte entre o widget de ofertas do kit (ewc-bundle) e a gaveta do tema (a da referência).
   Depois do add, o widget dispara 'ewc:cart:added'; aqui a gaveta é buscada de novo pela Section Rendering API e o
   elemento <cart-drawer> é trocado INTEIRO (o custom element novo se inicializa sozinho; trocar só o miolo deixa a
   gaveta presa no ramo vazio), a bolha do cabeçalho é atualizada e a gaveta abre. */
(function () {
  if (window.__blTema) return;
  window.__blTema = true;
  function atualizar() {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
        var novo = doc.querySelector('cart-drawer');
        var atual = document.querySelector('cart-drawer');
        if (novo && atual) { atual.replaceWith(novo); }
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var conta = b && b.querySelector('.cart-count-bubble');
          var velha = bolha.querySelector('.cart-count-bubble');
          if (velha) velha.remove();
          if (conta) bolha.appendChild(conta);
        }
        setTimeout(function () {
          var g = document.querySelector('cart-drawer');
          if (g && typeof g.open === 'function') g.open();
        }, 60);
      })
      .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; });
  }
  document.addEventListener('ewc:cart:added', atualizar);
})();
